/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type ListScopedApiKeysAuthApiKeysResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class ListScopedApiKeysAuthApiKeysResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ListScopedApiKeysAuthApiKeysResponse429ResponseBodyData;

  constructor(
    err: ListScopedApiKeysAuthApiKeysResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListScopedApiKeysAuthApiKeysResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type ListScopedApiKeysAuthApiKeysResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class ListScopedApiKeysAuthApiKeysResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ListScopedApiKeysAuthApiKeysResponse409ResponseBodyData;

  constructor(
    err: ListScopedApiKeysAuthApiKeysResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListScopedApiKeysAuthApiKeysResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type ListScopedApiKeysAuthApiKeysResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class ListScopedApiKeysAuthApiKeysResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ListScopedApiKeysAuthApiKeysResponse404ResponseBodyData;

  constructor(
    err: ListScopedApiKeysAuthApiKeysResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListScopedApiKeysAuthApiKeysResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type ListScopedApiKeysAuthApiKeysResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class ListScopedApiKeysAuthApiKeysResponseResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListScopedApiKeysAuthApiKeysResponseResponseBodyData;

  constructor(
    err: ListScopedApiKeysAuthApiKeysResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListScopedApiKeysAuthApiKeysResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type ListScopedApiKeysAuthApiKeysResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class ListScopedApiKeysAuthApiKeysResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListScopedApiKeysAuthApiKeysResponseBodyData;

  constructor(
    err: ListScopedApiKeysAuthApiKeysResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListScopedApiKeysAuthApiKeysResponseBody";
  }
}

/**
 * Bad request
 */
export type ListScopedApiKeysResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class ListScopedApiKeysResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListScopedApiKeysResponseBodyData;

  constructor(
    err: ListScopedApiKeysResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListScopedApiKeysResponseBody";
  }
}

/** @internal */
export const ListScopedApiKeysAuthApiKeysResponse429ResponseBody$inboundSchema:
  z.ZodType<
    ListScopedApiKeysAuthApiKeysResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListScopedApiKeysAuthApiKeysResponse429ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ListScopedApiKeysAuthApiKeysResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListScopedApiKeysAuthApiKeysResponse429ResponseBody$outboundSchema:
  z.ZodType<
    ListScopedApiKeysAuthApiKeysResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    ListScopedApiKeysAuthApiKeysResponse429ResponseBody
  > = z.instanceof(ListScopedApiKeysAuthApiKeysResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListScopedApiKeysAuthApiKeysResponse409ResponseBody$inboundSchema:
  z.ZodType<
    ListScopedApiKeysAuthApiKeysResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListScopedApiKeysAuthApiKeysResponse409ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ListScopedApiKeysAuthApiKeysResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListScopedApiKeysAuthApiKeysResponse409ResponseBody$outboundSchema:
  z.ZodType<
    ListScopedApiKeysAuthApiKeysResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    ListScopedApiKeysAuthApiKeysResponse409ResponseBody
  > = z.instanceof(ListScopedApiKeysAuthApiKeysResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListScopedApiKeysAuthApiKeysResponse404ResponseBody$inboundSchema:
  z.ZodType<
    ListScopedApiKeysAuthApiKeysResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListScopedApiKeysAuthApiKeysResponse404ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ListScopedApiKeysAuthApiKeysResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListScopedApiKeysAuthApiKeysResponse404ResponseBody$outboundSchema:
  z.ZodType<
    ListScopedApiKeysAuthApiKeysResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    ListScopedApiKeysAuthApiKeysResponse404ResponseBody
  > = z.instanceof(ListScopedApiKeysAuthApiKeysResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListScopedApiKeysAuthApiKeysResponseResponseBody$inboundSchema:
  z.ZodType<
    ListScopedApiKeysAuthApiKeysResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListScopedApiKeysAuthApiKeysResponseResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ListScopedApiKeysAuthApiKeysResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListScopedApiKeysAuthApiKeysResponseResponseBody$outboundSchema:
  z.ZodType<
    ListScopedApiKeysAuthApiKeysResponseResponseBody$Outbound,
    z.ZodTypeDef,
    ListScopedApiKeysAuthApiKeysResponseResponseBody
  > = z.instanceof(ListScopedApiKeysAuthApiKeysResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListScopedApiKeysAuthApiKeysResponseBody$inboundSchema: z.ZodType<
  ListScopedApiKeysAuthApiKeysResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new ListScopedApiKeysAuthApiKeysResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type ListScopedApiKeysAuthApiKeysResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListScopedApiKeysAuthApiKeysResponseBody$outboundSchema: z.ZodType<
  ListScopedApiKeysAuthApiKeysResponseBody$Outbound,
  z.ZodTypeDef,
  ListScopedApiKeysAuthApiKeysResponseBody
> = z.instanceof(ListScopedApiKeysAuthApiKeysResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const ListScopedApiKeysResponseBody$inboundSchema: z.ZodType<
  ListScopedApiKeysResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new ListScopedApiKeysResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type ListScopedApiKeysResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListScopedApiKeysResponseBody$outboundSchema: z.ZodType<
  ListScopedApiKeysResponseBody$Outbound,
  z.ZodTypeDef,
  ListScopedApiKeysResponseBody
> = z.instanceof(ListScopedApiKeysResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
